import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import { CheckCircleRounded, CloseRounded } from "@mui/icons-material";

interface AffiliateUpdateModalProps {
    open: boolean,
    setOpen: Function
}

const AffiliateUpdateModal = ({ open, setOpen }: AffiliateUpdateModalProps) => {
    const { t } = useTranslation(['salesmarketing', 'translation']);
    const navigate = useNavigate();

    return (
        <>
            <Dialog open={open} maxWidth={false}>
                <DialogTitle>
                    <Grid container item xs={12}>
                        <Grid item xs={1}>
                            <CheckCircleRounded color={"success"} />
                        </Grid>
                        <Grid item xs={10}>
                            <Typography color="primary" className="ModalTitle">
                                {t('salesmarketing:affiliate.updateModal.successTitle')}
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton sx={{position: 'absolute', right: 16, top: 12,}} onClick={() => { setOpen(false) }}>
                                <CloseRounded />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent className="ModalBody">
                    <Typography color="primary">
                        {t('salesmarketing:affiliate.updateModal.content')}
                    </Typography>
                </DialogContent>
                <DialogActions className="ModalFooter">
                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                        <Grid container item xs={12} rowSpacing={1} columnSpacing={3}
                              justifyContent={"flex-end"}>
                            <Grid item>
                                <Button fullWidth size="small" color={"accent"} onClick={() => { navigate("/salesmarketing/affiliatelist") }}>
                                    {t('salesmarketing:affiliate.buttons.close')}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default AffiliateUpdateModal;